import React from "react";
import { navigate } from "@reach/router";
import logoanai from "../../../images/logos/logoanai.png";

export default () => {
  return (
    <div className="login-bg">
      <div className="login-card" style={{ maxWidth: 440 }}>
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">Matrículas</div>
        <div className="login-subtitle">
          Seleccione el tipo de estudiante
        </div>

        <button
          className="btn-modern btn-primary"
          onClick={() => navigate("authNew")}
        >
          🆕 Nuevo Estudiante
        </button>

        <button
          className="btn-modern btn-outline"
          style={{ marginTop: 16 }}
          onClick={() => navigate("/")}
        >
          ← Volver al inicio
        </button>

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
};
